// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M3 2H13', 'M12 8.5L8 4.5L4 8.5M8 4.5V14'];
